import { render, staticRenderFns } from "./RServerDataTable.vue?vue&type=template&id=609ff7a4&"
import script from "./RServerDataTable.vue?vue&type=script&lang=js&"
export * from "./RServerDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports